import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'pulse-checkmark',
  templateUrl: './checkmark.component.html',
  styleUrls: ['./checkmark.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckmarkComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
